import { RoleAccessUpdateSuccess, getUserDetailsActionSuccess, roleAceessAction, roleAceessActionSuccess } from "../../store/actions";
import { getpartysetting_API } from "../../store/Administrator/PartySetting/action";
import { commonPartyDropSelectAction, getCommonPartyDrodownOptionAction } from "../../store/Utilites/PartyDrodown/action";
import { impersonationResetState, impersonationSetState } from "../../store/Utilites/Impersonation/action";
import { GET_COMPANY_FROM_URL, loginCompanyID } from "./CommonFunction";
import { customAlert } from "../../CustomAlert/ConfirmDialog";
import { showToastAlert } from "../../helpers/axios_Config";

const selectedPartyDefault = { value: 0, label: "select party...", SAPPartyCode: "" };

const safeJsonParse = (value, fallback = null) => {
    try {
        return value ? JSON.parse(value) : fallback;
    } catch (error) {
        return fallback;
    }
};

export const impersonationStorageKeys = () => {
    const company = GET_COMPANY_FROM_URL();
    return {
        originalUserSession: `${company}_originalUserSession`,
        isImpersonating: `${company}_isImpersonating`,
    };
};

export const getUserDisplayNameForImpersonation = (user = {}) => {
    return user.SwitchEmployeeName || user.EmployeeName || user.Employee_Name || user.SwitchUserName || user.UserName || user.LoginName || user.PartyName || "User";
};

export const normalizeSwitchUserRecord = (row = {}) => {
    const employeeId = row.Employee_id || row.EmployeeID || row.Employee || row.employee || row.id;
    const userId = row.UserID || row.UserId || row.userId || row.id;
    const loginName = row.LoginName || row.UserName || row.Name || "";
    const employeeName = row.EmployeeName || row.Employee_Name || row.Name || loginName;

    return {
        ...row,
        value: employeeId,
        label: employeeName && loginName && employeeName !== loginName ? `${employeeName} (${loginName})` : employeeName || loginName,
        Employee_id: employeeId,
        UserID: userId,
        UserName: loginName,
        EmployeeName: employeeName,
    };
};

export const makeSessionSnapshot = () => {
    const company = GET_COMPANY_FROM_URL();
    return {
        roleId: safeJsonParse(localStorage.getItem(`${company}_roleId`)),
        selectedParty: safeJsonParse(localStorage.getItem(`${company}_selectedParty`)),
        userId: localStorage.getItem(`${company}_userId`),
        userName: localStorage.getItem(`${company}_UserName`),
        employeeId: localStorage.getItem(`${company}_EmployeeID`),
        employeeName: localStorage.getItem(`${company}_EmployeeName`),
    };
};

export const restoreSessionSnapshot = (snapshot = {}) => {
    const company = GET_COMPANY_FROM_URL();

    if (snapshot.roleId) {
        localStorage.setItem(`${company}_roleId`, JSON.stringify(snapshot.roleId));
    }

    if (snapshot.selectedParty) {
        localStorage.setItem(`${company}_selectedParty`, JSON.stringify(snapshot.selectedParty));
    }

    if (snapshot.userId !== undefined && snapshot.userId !== null) {
        localStorage.setItem(`${company}_userId`, snapshot.userId);
    }

    if (snapshot.userName !== undefined && snapshot.userName !== null) {
        localStorage.setItem(`${company}_UserName`, snapshot.userName);
    }

    if (snapshot.employeeId !== undefined && snapshot.employeeId !== null) {
        localStorage.setItem(`${company}_EmployeeID`, snapshot.employeeId);
    }

    if (snapshot.employeeName !== undefined && snapshot.employeeName !== null) {
        localStorage.setItem(`${company}_EmployeeName`, snapshot.employeeName);
    }
};

export const clearRoleAccessForUserSwitch = (dispatch) => {
    dispatch(roleAceessActionSuccess([]));
    dispatch(RoleAccessUpdateSuccess([]));
};

export const refreshDisplayedLoginUser = (user = {}, dispatch) => {
    const company = GET_COMPANY_FROM_URL();
    dispatch(getUserDetailsActionSuccess({
        ...user,
        Party_id: user.Party_id === null ? 0 : user.Party_id,
        UserName: localStorage.getItem(`${company}_UserName`) || user.UserName,
        EmployeeName: localStorage.getItem(`${company}_EmployeeName`) || getUserDisplayNameForImpersonation(user),
    }));
};

export const runLoginUserBootstrap = (user, dispatch, options = {}) => {
    const company = GET_COMPANY_FROM_URL();
    const employeeId = user.Employee_id || user.EmployeeID || user.Employee;
    const partyId = user.Party_id === null ? 0 : user.Party_id;
    const partyName = user.PartyName;
    const preserveSelectedParty = options.preserveSelectedParty === true;
    const loginParties = safeJsonParse(localStorage.getItem(`${company}_LoginUserParties`), []);
    const loginParty = user.id != null ? (loginParties.find(p => p.id === user.id) || {}) : {};
    const fullUser = { ...loginParty, ...user };

    if (user.PartyType === "Company Division") {
        const selectedParty = preserveSelectedParty
            ? safeJsonParse(localStorage.getItem(`${company}_selectedParty`))
            : null;

        if (selectedParty && selectedParty.value > 0) {
            dispatch(commonPartyDropSelectAction(selectedParty));
        } else {
            dispatch(commonPartyDropSelectAction(selectedPartyDefault));
            localStorage.setItem(`${company}_selectedParty`, JSON.stringify(selectedPartyDefault));
        }
    } else {
        const userParty = { value: partyId, label: partyName, SAPPartyCode: "" };
        dispatch(commonPartyDropSelectAction(userParty));
        localStorage.setItem(`${company}_selectedParty`, JSON.stringify(userParty));
    }
    
    localStorage.setItem(`${company}_roleId`, JSON.stringify({ ...fullUser, Employee_id: employeeId, Party_id: partyId }));
    localStorage.setItem("Logout", "");

    refreshDisplayedLoginUser({ ...fullUser, Employee_id: employeeId, Party_id: partyId }, dispatch);
    dispatch(roleAceessAction(partyId, employeeId, loginCompanyID()));
    dispatch(getpartysetting_API(partyId, loginCompanyID()));
    dispatch(getCommonPartyDrodownOptionAction());
};

export const switchBackToOriginalUser = async (dispatch, options = {}) => {
    const shouldConfirm = options.confirm !== false;
    const isCurrentlyImpersonating = options.isImpersonating === true;
    const { originalUserSession, isImpersonating: isImpersonatingKey } = impersonationStorageKeys();

    if (!isCurrentlyImpersonating && localStorage.getItem(isImpersonatingKey) !== "true") {
        showToastAlert("You are already viewing as your own user.", "warning");
        return false;
    }

    const snapshot = safeJsonParse(localStorage.getItem(originalUserSession));

    if (!snapshot?.roleId) {
        localStorage.removeItem(originalUserSession);
        localStorage.removeItem(isImpersonatingKey);
        dispatch(impersonationResetState());
        customAlert({ Type: 4, Message: "Original user session was not found. Please logout and login again." });
        return false;
    }

    if (shouldConfirm) {
        const isConfirmed = await customAlert({
            Type: 7,
            Message: `Switch back to ${getUserDisplayNameForImpersonation(snapshot.roleId)}?`,
        });

        if (!isConfirmed) {
            return false;
        }
    }

    restoreSessionSnapshot(snapshot);
    clearRoleAccessForUserSwitch(dispatch);
    runLoginUserBootstrap(snapshot.roleId, dispatch, { preserveSelectedParty: true });

    localStorage.removeItem(originalUserSession);
    localStorage.removeItem(isImpersonatingKey);
    dispatch(impersonationResetState());
    showToastAlert(`Back to viewing as ${getUserDisplayNameForImpersonation(snapshot.roleId)}`, "success");
    return true;
};

export const initializeImpersonationFromStorage = (dispatch) => {
    const { originalUserSession, isImpersonating } = impersonationStorageKeys();

    if (localStorage.getItem(isImpersonating) !== "true") {
        dispatch(impersonationResetState());
        return;
    }

    const originalSession = safeJsonParse(localStorage.getItem(originalUserSession));
    const activeSession = makeSessionSnapshot();

    if (!originalSession || !activeSession.roleId) {
        localStorage.removeItem(isImpersonating);
        localStorage.removeItem(originalUserSession);
        dispatch(impersonationResetState());
        return;
    }

    dispatch(impersonationSetState({
        isImpersonating: true,
        originalUser: originalSession.roleId,
        activeUser: activeSession.roleId,
    }));
    runLoginUserBootstrap(activeSession.roleId, dispatch, { preserveSelectedParty: true });
};
